import { Container, Typography } from '@material-ui/core';
import React from 'react';
export const NotAuthenticated = () => /*#__PURE__*/React.createElement(Container, {
  maxWidth: "sm"
}, /*#__PURE__*/React.createElement(Typography, {
  component: "h1",
  gutterBottom: true
}, "Authentication"), /*#__PURE__*/React.createElement(Typography, {
  variant: "body1"
}, "You are not authenticated."));
//# sourceMappingURL=not-authenticated.js.map